import type { FieldPath, FieldValues } from "react-hook-form";
import { CdcSelectField, type CdcSelectFieldProps } from "./cdc-field-helpers";
import usStates from "@/data/us-states.json" with { type: "json" };

const STATE_OPTIONS = usStates;

export type CdcAddressStateFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<CdcSelectFieldProps<TFieldValues, TName>, "fieldKey" | "options">;

export function CdcAddressStateField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  locale,
  ...rest
}: Readonly<CdcAddressStateFieldProps<TFieldValues, TName>>) {
  return (
    <CdcSelectField
      {...rest}
      fieldKey="state"
      locale={locale}
      options={STATE_OPTIONS}
    />
  );
}
